import React from "react"

import { FeedbackType } from "shared/types/FeedbackType"

import { useFeedbackButtonViewModel } from "./model/useFeedbackButtonViewModel"
import { FeedbackButtonView } from "./ui/FeedbackButtonView"

export interface FeedbackButtonModel {
  isHidden?: boolean
  hidePopup?: boolean
  onClick?: React.MouseEventHandler
  onFeedbackTypeSelect: (feedbackType: FeedbackType) => void
}

export interface FeedbackButtonProps extends FeedbackButtonModel {
  isDefaultOpen?: boolean
}

export const FeedbackButton = React.memo((props: FeedbackButtonProps) => (
  <FeedbackButtonView {...useFeedbackButtonViewModel(props)} />
))
